exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collapsed>.when-open[data-v-69126128],.not-collapsed>.when-closed[data-v-69126128]{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./resources/js/components/service/ResultPeriodical.vue?vue&type=style&index=0&id=69126128&lang=scss&scoped=true&
// module id = 9JNa
// module chunks = 0